export default __webpack_public_path__ + "static/media/Details-03.b475419e.jpg";